import { DEFAULT_TABS } from "../../../../settings/features/advanced-tabs/group/defaults";

export const ADVANCED_TABS_GROUP_TEMPLATES = [
  {
    style: "default",
    alignment: "center",
    width: 60,
    active: "#0065FF",
    inactive: "#42526E",
    hover: "#0065FF",
    colors: {
      accent: { dark: "#00AFFF", light: "#00AFFF" },
      text: { dark: "#00AFFF", light: "#00AFFF" },
    },
    tabs: DEFAULT_TABS,
    iconPreview: false,
  },
  {
    style: "rounded",
    alignment: "center",
    width: 60,
    active: "#0065FF",
    inactive: "#42526E",
    hover: "#0065FF",
    colors: {
      accent: { dark: "#00afff26", light: "#00afff26" },
      text: { dark: "#00AFFF", light: "#00AFFF" },
    },
    tabs: DEFAULT_TABS,
    iconPreview: false,
  },
  {
    style: "roundedBackground",
    alignment: "center",
    width: 60,
    active: "#0065FF",
    inactive: "#42526E",
    hover: "#0065FF",
    colors: {
      accent: { dark: "#FFF", light: "#FFF" },
      text: { dark: "#00AFFF", light: "#00AFFF" },
    },
    tabs: DEFAULT_TABS,
    iconPreview: false,
  },
];

export const getAdvancedTabsGroupTemplates = () =>
  ADVANCED_TABS_GROUP_TEMPLATES.map((template) => ({
    ...template,
  }));
